import type { BrokerAccountRef } from "./brokerAccountRef";

export function brokerAccountNotesEntityId(account: BrokerAccountRef): string {
  const brokerName = account.brokerName.trim().toLowerCase();
  const brokerAccountCode = account.brokerAccountCode.trim();
  return `${brokerName}:${brokerAccountCode}`;
}
